import { LINKS } from "@/data";

const SOCIALS = [
  ["SPOTIFY", LINKS.spotify],
  ["APPLE MUSIC", LINKS.apple],
  ["INSTAGRAM", LINKS.instagram],
  ["YOUTUBE", LINKS.youtube],
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="py-10 flex flex-wrap justify-center gap-x-8 gap-y-3 px-6">
      {SOCIALS.map(([label, href]) => (
        <a key={label} href={href} target="_blank" rel="noopener noreferrer" data-testid={`footer-${label.toLowerCase().replace(" ", "-")}`}
          className="text-[11px] tracking-[0.25em] text-[#6b6f76] hover:text-white transition-colors duration-300">
          {label}
        </a>
      ))}
    </footer>
  );
}
